// @flow
export const isNumber = (value: string) =>
  Number.isFinite(Number.parseFloat(value));



// WEBPACK FOOTER //
// ./src/util/NumberUtils.js